<template>
  <v-row justify="center">
    <v-btn v-if="!alreadyInAMeeting" color="primary" dark :loading="loading" @click="joinRoom"
      >Kliknij tutaj aby dołączyć do spotkania</v-btn
    >
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-dialog v-model="warnDialog" max-width="400">
            <template v-slot:activator="{ on: modelOn }">
              <v-tooltip bottom dark>
                <template v-slot:activator="{ on: tooltipOn }">
                  <v-btn icon dark v-on="{ ...modelOn, ...tooltipOn }">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Opuść spotkanie</span>
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="warning" dark flat>
                <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="mt-4">
                <p>Czy na pewno chcesz opuścić spotkanie?</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn class="text--secondary" text :disabled="dialog.loading" @click="warnDialog = false">Nie</v-btn>
                <v-btn color="warning" text :loading="dialog.loading" @click="close">Tak</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-toolbar-title>Spotkanie</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center">
          <iframe
            v-if="showIframe"
            allow="geolocation; microphone; camera; fullscreen"
            :src="url"
            :height="windowSize.height - 84"
            :width="windowSize.width"
          />
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BigBlueButtonServiceApi from '@/api/bigBlueButtonServiceApi.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      warnDialog: false,
      loading: false,
      url: null,
      showIframe: false,
      windowSize: {
        width: 0,
        height: 0
      },
      alreadyInAMeeting: false
    };
  },
  computed: {
    ...mapAccountState(['token']),
    execution() {
      return JSON.parse(this.element.execution);
    },
    embedUrl() {
      return this.execution.url;
    }
  },
  methods: {
    async joinRoom() {
      try {
        this.loading = true;
        const { data } = await new BigBlueButtonServiceApi(this.token).joinRoom(
          this.element.id,
          this.element.elementType,
          this.element.state,
          this.element.execution
        );

        if (data.result.alreadyInAMeeting) {
          this.alreadyInAMeeting = true;
          this.$emit('alreadyInAMeeting');
          return;
        }

        // this.url = data.result.uri;
        // this.onResize();
        window.open(data.result.uri);

        this.loading = false;
        // this.dialog = true;
      } catch (e) {
        console.error(e);
        // TODO: handle
      }
    },
    onResize() {
      this.windowSize = { width: window.innerWidth, height: window.innerHeight };
      this.showIframe = true;
    },
    close() {
      this.dialog = false;
      this.showIframe = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
